module.exports = __webpack_public_path__ + "static/media/default_image.e0a0fb98.webp";